(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
    }

    hide() {
      super.hide(this.isProductPage);
      window.pauseAllMedia();
      // pauseAllMedia() del tema non tocca i video del modal: li fermo a mano
      this.querySelectorAll('video').forEach((v) => {
        try {
          v.pause();
        } catch (e) {}
      });
      // Riprendo i video della galleria rimasti in vista
      setTimeout(() => {
        if (typeof window.cwsResumeGalleryVideos === 'function') window.cwsResumeGalleryVideos();
      }, 100);
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (!activeMedia) return;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // === MOBILE FULLSCREEN SLIDER (gallery_type: two_column_mobile_slider) ===
  (function () {
    const SEL = '.product__mobile-slider';
    const MQ = window.matchMedia('(max-width: 749px)');

    const initOne = (el) => {
      if (el.swiper) return true;
      if (typeof Swiper === 'undefined') return false;
      if (!el.offsetParent || el.offsetWidth === 0) return false;

      const paginationEl = el.querySelector('.product__mobile-slider-pagination');
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        threshold: 3,
        pagination: paginationEl
          ? {
              el: paginationEl,
              type: 'progressbar',
            }
          : false,
      });
      el.classList.remove('mobile-slider--fallback');
      if (!el.__cwsScrollGuard) {
        el.__cwsScrollGuard = true;
        el.addEventListener('scroll', () => {
          if (el.classList.contains('mobile-slider--fallback')) return;
          if (el.scrollLeft !== 0) el.scrollLeft = 0;
          if (el.scrollTop !== 0) el.scrollTop = 0;
        });
      }
      return true;
    };

    const initAll = () => {
      if (!MQ.matches) return true;
      const nodes = document.querySelectorAll(SEL);
      if (!nodes.length) return true;
      let ok = true;
      nodes.forEach((el) => {
        if (!initOne(el)) ok = false;
      });
      return ok;
    };

    const enableFallback = () => {
      document.querySelectorAll(SEL).forEach((el) => {
        if (!el.swiper) el.classList.add('mobile-slider--fallback');
      });
    };

    const boot = () => {
      if (initAll()) return;
      let tries = 0;
      const iv = setInterval(() => {
        tries += 1;
        if (initAll()) {
          clearInterval(iv);
          return;
        }
        if (tries > 50) {
          clearInterval(iv);
          enableFallback();
        }
      }, 200);
    };

    const refresh = () => {
      document.querySelectorAll(SEL).forEach((el) => {
        if (el.swiper) el.swiper.update();
      });
      boot();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    window.addEventListener('load', refresh);
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:select', refresh);

    if (MQ.addEventListener) {
      MQ.addEventListener('change', refresh);
    } else if (MQ.addListener) {
      MQ.addListener(refresh);
    }
  })();

  // === AUTOPLAY + LOOP VIDEO (GALLERY + MODAL) ===
  (function () {
    const YT_PARAMS = { autoplay: '1', mute: '1', playsinline: '1', enablejsapi: '1', loop: '1' };
    const VM_PARAMS = { autoplay: '1', muted: '1', loop: '1' };

    const addQueryParams = (url, params) => {
      try {
        const u = new URL(url, window.location.origin);
        Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
        return u.toString();
      } catch {
        const hasQ = url.includes('?');
        const qs = Object.entries(params)
          .map(([k, v]) => `${k}=${v}`)
          .join('&');
        return url + (hasQ ? '&' : '?') + qs;
      }
    };

    const ensureIframeAutoplay = (iframe) => {
      if (!iframe) return;
      const allow = iframe.getAttribute('allow') || '';
      if (!/autoplay/i.test(allow)) {
        iframe.setAttribute(
          'allow',
          (allow ? allow + '; ' : '') + 'autoplay; fullscreen; encrypted-media; picture-in-picture'
        );
      }
      const src = iframe.getAttribute('src') || '';
      const low = src.toLowerCase();
      if (low.includes('youtube.com') || low.includes('youtube-nocookie.com')) {
        if (!(low.includes('loop=1') && low.includes('playlist='))) {
          const videoId = (src.match(/embed\/([^?]+)/) || [])[1] || '';
          iframe.src = addQueryParams(src, { ...YT_PARAMS, playlist: videoId });
        }
      } else if (low.includes('vimeo.com')) {
        if (!low.includes('loop=1')) {
          iframe.src = addQueryParams(src, VM_PARAMS);
        }
      }
    };

    const isInViewport = (el) => {
      const r = el.getBoundingClientRect();
      return (
        r.width > 0 &&
        r.height > 0 &&
        r.bottom > 0 &&
        r.right > 0 &&
        r.top < window.innerHeight &&
        r.left < window.innerWidth
      );
    };

    // Riavvia i video della galleria visibili (dopo chiusura modal o dopo pauseAllMedia del tema)
    const resumeVisibleGalleryVideos = () => {
      document
        .querySelectorAll('.product__media-list video, .product__mobile-slider .swiper-slide-active video')
        .forEach((v) => {
          if (v.closest('.product-media-modal')) return;
          const slide = v.closest('.swiper .swiper-slide');
          if (slide && !slide.classList.contains('swiper-slide-active')) return;
          if (v.paused && isInViewport(v)) v.play().catch(() => {});
        });
    };
    window.cwsResumeGalleryVideos = resumeVisibleGalleryVideos;

    const playNativeVideo = (v) => {
      if (!v) return;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.loop = true;
      const slide = v.closest('.product__mobile-slider-item');
      if (slide) {
        v.controls = false;
        v.removeAttribute('controls');
        v.style.pointerEvents = 'none';
      }
      if (!v.__cwsLoopBound) {
        v.__cwsLoopBound = true;
        v.addEventListener('ended', () => {
          v.currentTime = 0;
          v.play().catch(() => {});
        });
        if (slide) {
          v.addEventListener('playing', () => slide.classList.remove('is-video-blocked'));
        }
      }
      v.play().catch((err) => {
        // Solo blocco autoplay (es. iOS Risparmio energetico), non le interruzioni da pause()
        if (err && err.name && err.name !== 'NotAllowedError') return;
        if (!slide) return;
        slide.classList.add('is-video-blocked');
        if (slide.__cwsTapBound) return;
        const sw = slide.closest('.product__mobile-slider')?.swiper;
        if (!sw) return;
        slide.__cwsTapBound = true;
        sw.on('click', () => {
          if (sw.slides[sw.activeIndex] === slide) v.play().catch(() => {});
        });
      });
    };

    const clickPosterSafely = (btn) => {
      if (!btn) return;
      const saved = [];
      let node = btn.parentElement;
      while (node && node !== document.body) {
        saved.push([node, node.scrollLeft, node.scrollTop]);
        node = node.parentElement;
      }
      const x = window.scrollX,
        y = window.scrollY;
      try {
        btn.click();
      } catch (e) {}
      saved.forEach(([n, sl, st]) => {
        n.scrollLeft = sl;
        n.scrollTop = st;
      });
      window.scrollTo(x, y);
    };

    const loadDeferred = (root) => {
      const dm = root.querySelector('deferred-media');
      if (!dm) return false;
      if (dm.__cwsLoaded || dm.hasAttribute('loaded')) return true;
      dm.__cwsLoaded = true;
      // loadContent() del tema fa sempre focus() sul video: salvo e ripristino lo scroll
      const x = window.scrollX,
        y = window.scrollY;
      if (typeof dm.loadContent === 'function') dm.loadContent();
      else clickPosterSafely(dm.querySelector('.deferred-media__poster'));
      window.scrollTo(x, y);
      // loadContent() chiama pauseAllMedia(): riavvio gli altri video della galleria in vista
      if (!dm.closest('.product-media-modal')) setTimeout(resumeVisibleGalleryVideos, 80);
      return true;
    };

    const hasMedia = (root) => !!root && !!root.querySelector('video, iframe, deferred-media');

    const activateAutoplayIn = (root) => {
      if (!hasMedia(root)) return;
      loadDeferred(root);
      // Play sincrono: se arriviamo da uno swipe/tap iOS lo tratta come avviato dall'utente
      root.querySelectorAll('video').forEach(playNativeVideo);
      root.querySelectorAll('iframe').forEach(ensureIframeAutoplay);
      // Secondo passaggio per contenuti inseriti in ritardo
      setTimeout(() => {
        root.querySelectorAll('video').forEach((v) => {
          if (v.paused) playNativeVideo(v);
        });
        root.querySelectorAll('iframe').forEach(ensureIframeAutoplay);
      }, 60);
    };

    const handleSwiper = (swiper) => {
      const onChange = () => {
        swiper.slides.forEach((slide) => {
          if (!slide.classList.contains('swiper-slide-active')) {
            slide.querySelectorAll('video').forEach((v) => {
              try {
                v.pause();
              } catch (e) {}
            });
          }
        });
        activateAutoplayIn(swiper.slides[swiper.activeIndex]);
      };
      setTimeout(onChange, 120);
      swiper.on('slideChange', onChange);
      swiper.on('slideChangeTransitionEnd', onChange);
    };

    const initGallery = () => {
      document.querySelectorAll('.js-media-list.swiper, .product__mobile-slider').forEach((el) => {
        const boot = () => {
          const sw = el.swiper;
          if (!sw) return false;
          if (!sw.__cwsAutoplayBound) {
            sw.__cwsAutoplayBound = true;
            handleSwiper(sw);
          }
          const active = el.querySelector('.swiper-slide-active');
          if (active) activateAutoplayIn(active);
          return true;
        };
        if (!boot()) {
          let tries = 0;
          const iv = setInterval(() => {
            if (boot() || ++tries > 40) clearInterval(iv);
          }, 150);
        }
      });
    };

    // Modal: all'apertura carico e avvio il video del media cliccato
    const initModal = () => {
      document.querySelectorAll('product-modal').forEach((m) => {
        if (m.__cwsModalBound) return;
        m.__cwsModalBound = true;
        const run = () => {
          if (!m.hasAttribute('open')) return;
          const id = m.openedBy && m.openedBy.getAttribute('data-media-id');
          if (!id) return;
          const target = m.querySelector(`.product-media-modal__content [data-media-id="${id}"]`);
          if (!target) return;
          activateAutoplayIn(target.closest('.product-media-modal__item') || target);
        };
        new MutationObserver(() => setTimeout(run, 50)).observe(m, {
          attributes: true,
          attributeFilter: ['open'],
        });
      });
    };

    const watchDynamicMedia = () => {
      const mo = new MutationObserver((muts) => {
        muts.forEach((m) => {
          m.addedNodes &&
            m.addedNodes.forEach((node) => {
              if (!(node instanceof HTMLElement)) return;
              const slide = node.closest ? node.closest('.swiper-slide') : null;
              if (slide && !slide.classList.contains('swiper-slide-active')) return;
              if (node.matches('video')) playNativeVideo(node);
              else if (node.matches('iframe')) ensureIframeAutoplay(node);
              else if (node.querySelector) {
                node.querySelectorAll('video').forEach(playNativeVideo);
                node.querySelectorAll('iframe').forEach(ensureIframeAutoplay);
              }
            });
        });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    };

    // Layout statici (griglia desktop): play quando il video è visibile, pausa quando esce
    let staticObserver = null;
    const initStatic = () => {
      if (!('IntersectionObserver' in window)) return;
      if (!staticObserver) {
        staticObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                activateAutoplayIn(e.target);
              } else {
                e.target.querySelectorAll('video').forEach((v) => {
                  try {
                    v.pause();
                  } catch (err) {}
                });
              }
            });
          },
          { threshold: 0.4 }
        );
      }
      document
        .querySelectorAll('.product__media-list-wrapper > .product__media-list:not(.swiper) .product__media-item')
        .forEach((item) => {
          if (item.__cwsObserved || !hasMedia(item)) return;
          item.__cwsObserved = true;
          staticObserver.observe(item);
        });
    };

    let started = false;
    const start = () => {
      initGallery();
      initStatic();
      initModal();
      if (started) return;
      started = true;
      watchDynamicMedia();
    };

    // {% javascript %} può essere eseguito dopo DOMContentLoaded: controlla readyState
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    window.addEventListener('load', start);
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();
})();
